module.exports = __webpack_public_path__ + "img/Education.12e6153f.png";